import React from 'react'
import PropTypes from 'prop-types'
import {
  Form,
  FormInput,
  FormButton,
  Margin,
  Text,
  Row,
  Col,
} from 'shared/components'
import { Label } from 'shared/components/newInput/Label'

import * as styles from './styles'

const SponsorFormComponent = ({
  form,
  onSubmitForm,
  getOptionLabel,
  getOptionValue,
  loadJurisdictions,
}) => (
  <Form form={form} onSubmit={onSubmitForm} css={styles.smallerLabels}>
    <Margin tb={1}>
      <Row>
        <Col xs={12}>
          <FormInput
            name="contactFirstName"
            label="Contact Person's First Name *"
            placeholder="First Name"
          />
        </Col>
        <Col xs={12}>
          <FormInput
            name="contactLastName"
            label="Contact Person's Last Name *"
            placeholder="Last Name"
          />
        </Col>
      </Row>
    </Margin>

    <Margin bottom={1}>
      <FormInput
        name="email"
        label="Contact Person's email address *"
        type="email"
        placeholder="account@email.com"
      />
    </Margin>

    <Margin tb={1}>
      <FormInput
        name="sponsorName"
        label="Company's Name *"
        placeholder="Company/organization name"
      />
    </Margin>

    <Margin tb={1}>
      <FormInput
        name="website"
        label="Company's website *"
        placeholder="URL to the website"
      />
    </Margin>

    <Margin tb={1}>
      <Row>
        <Col xs={6}>
          <Label label="Country" />
          <FormInput
            oldInput
            cacheOptions
            defaultOptions
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            type="async-select"
            name="country"
            placeholder="Select country"
            loadOptions={loadJurisdictions}
            bordered
          />
        </Col>
        <Col xs={6}>
          <FormInput
            name="zip"
            label="Postal Code/ZIP Code"
            placeholder="Postal or ZIP code"
          />
        </Col>
      </Row>
    </Margin>
    <Margin tb={1}>
      <Row>
        <Col xs={6}>
          <FormInput
            label="State/Province/Region"
            name="state"
            placeholder="Name of the state etc."
          />
        </Col>
        <Col xs={6}>
          <FormInput
            label="City/Town"
            name="city"
            placeholder="Name of the city or town"
          />
        </Col>
      </Row>
    </Margin>
    <Margin tb={1}>
      <FormInput
        label="Address Line 1"
        name="address1"
        placeholder="Street number and name (e.g., 123 Main St)"
      />
    </Margin>
    <Margin tb={1}>
      <FormInput
        label="Address Line 2"
        name="address2"
        placeholder="Apartment, suite, unit, building, floor"
      />
    </Margin>

    <Margin top={2} css={styles.buttonContainer}>
      <FormButton submit size="large" css={styles.signupButton}>
        <Text size={11} upper bold black>
          Contact InWin
        </Text>
      </FormButton>
    </Margin>
  </Form>
)

SponsorFormComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  onSubmitForm: PropTypes.func.isRequired,
  getOptionLabel: PropTypes.func.isRequired,
  getOptionValue: PropTypes.func.isRequired,
  loadJurisdictions: PropTypes.func.isRequired,
}

export default SponsorFormComponent
